import React, { Component } from 'react';

class TextRotate extends Component {
    constructor() {
        super();

        this.setTimeout = null;

        this.state = {
            text: ''
        }
    }

    render() { 
        return ( 
            <span>{this.state.text}&nbsp;</span>
         );
    }

    componentDidMount() {
        const textArray = this.props.textArray;
        let period = this.props.period || 2000;
        this.animateText(textArray, period);
    }

    componentWillUnmount() {
        clearTimeout(this.setTimeout);
    }

    animateText(textArray, period, increment = 0, isDeleting = false) {
        let index = increment%textArray.length;
        let fullText = textArray[index];
        let currentText = isDeleting ? fullText.substring(0, this.state.text.length - 1) : fullText.substring(0, this.state.text.length + 1);
        this.setState({text: currentText});

        let _this = this;
        this.setTimeout = setTimeout(function(){
            if(currentText.length === fullText.length){
                isDeleting = true;
                period/= 3;
            }
            if(currentText.length === 0) {
                isDeleting = false;
                increment++;
                period *= 3;
            }    
            _this.animateText(textArray, period, increment, isDeleting);  
        },period)
    }
}
 
export default TextRotate;